// @magic
import Vue from 'vue';

import map from 'lodash/map';
import cond from 'lodash/cond';
import matches from 'lodash/matches';

import './validate.less';

const CN = 'validate';

const INPUT_CN = `${CN}__input`;
const INPUT_ERROR_CN = `${INPUT_CN}--error`;

const SPAN_CN = `${CN}__message`;

const _detectMessage = cond([
   [ matches({ name: 'required' }), () => 'The field is required' ],
   [ matches({ name: 'minLength' }), ({ params }) => `Please enter at least ${params.min} characters` ]
]);

const _getMessages = ($v) => {
   const iterator = ({name}) => !$v[name];
   return $v.$flattenParams().filter(iterator).map(_detectMessage);
};

Vue.component('validate', {
   functional: true,
   render,
   props: {
      field: { type: String, required: true },
      label: String
      // ,
      // asList: { type: Boolean, default: false }
   }
});

const RENDER_FNS = [ _label, _input, _errors ];


// label.validate
//    | {{ label }}
//    slot
//       input.validate__input.validate__input--error(type="text",v-model="?",...attrs)
//    span.validate__message some error here
function render(createElement, context) {
   const props = {
      class: { [CN]: true, [context.data.staticClass]: true }
   };

   const childs = map(RENDER_FNS, fn => fn(context, createElement));
   return createElement('label', props, childs);
}

function _input(context, createElement) {
   const { field } = context.props;

   const props = {
      attrs: { type: 'text', ...context.data.attrs },
      class: { [INPUT_CN]: true, [INPUT_ERROR_CN]: context.parent.$v[field].$error },
      domProps: {
         value: context.parent[field]
      },
      on: {
         input(e) {
            context.parent[field] = e.target.value;
            context.parent.$v[field].$touch();
         },
         blur() {
            context.parent.$v[field].$touch();
         }
      }
   };
   return createElement('input', props);
}

function _errors(context, createElement) {
   const { field } = context.props;
   const $v = context.parent.$v[field];

   if (!$v.$error) {
      return null;
   }

   return _renderSingleError(createElement, _getMessages($v));
}

function _renderSingleError(createElement, [message]) {
   const params = {
      class: { [SPAN_CN]: true }
   };
   return createElement('span', params, message);
}

function _label(context) {
   return context.props.label;
}
